import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const ChristmasIsland: Country = {
    identifier: "ChristmasIsland",
    name: "Christmas Island",
    countryCode: "CX",
    group: CountryGroup.OCEANIA,
    isUNMember: false,
    flag: "🇨🇽",
    svgPath: "m 771.61175,492.3404 -0.08,0.202 -0.147,-0.111 -0.169,-0.036 0.033,-0.15 0.139,-0.021 0.069,-0.008 0.099,-0.053 z",
}
